var $807554f8230db0ed$exports = {};
$807554f8230db0ed$exports = {
    "alpha": `Alfa`,
    "blue": `Modr\xe1`,
    "brightness": `Jas`,
    "green": `Zelen\xe1`,
    "hue": `Odst\xedn`,
    "lightness": `Sv\u{11B}tlost`,
    "red": `\u{10C}erven\xe1`,
    "saturation": `Sytost`
};


export {$807554f8230db0ed$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
